<template>
    <CustomButton :to="{ name: 'listMegaMenusCategories' }" label="Links.goBack" />
    <p class="page-title">Création d'une mise en avant</p>
    <div class="form-container">
        <div class="justify-center">
            <div class="mx-auto shadow-md p-6 rounded-lg w-[90%] md:w-[80%] lg:w-[50%]">
                <FormKit
                    type="form"
                    :value="true"
                    :actions="false"
                    incomplete-message="Désolé, tous les champs ne sont pas remplis correctement."
                    @submit="submitHandler"
                >
                    
                    <FormKit type="autocomplete"
                             name="category"
                             label="Choix de la catégorie *"
                             placeholder="Choisissez une catégorie"
                             validation="required"
                             :options="categories"
                             :validation-messages="{
                    required: 'La catégorie est obligatoire',
                  }"
                    />
                    <FormKit
                        type="text"
                        name="name"
                        label="Nom de la mise en avant *"
                        placeholder="Entrer un nom de la mise en avant"
                        validation="required|length:1,50"
                        :validation-messages="{
                required: 'Ce champ est obligatoire.',
                length: 'Ce champ doit contenir maximum 50 caractères.',
                }"
                    />
                    <FormKit type="autocomplete"
                             name="propertyValue"
                             label="Tag de recherche *"
                             placeholder="Sélectionner une tag"
                             validation="required"
                             :options="searchTags"
                             :validation-messages="{
                    required: 'La tag est obligatoire',
                  }"
                    />
                    <div class="w-full lg:w-3/4 ">
                        <label class="font-bold text-sm">Image *</label>
                        <UploadImage :image-preview-url="imageMenu ? imageMenu.url : getBaseUrl() + '/media/blank2.png'"
                                     @image-removed="onImageRemoved"
                                     @imageUploaded="onImageUpload"
                                     @error="onImageUploadError"
                        />
                    </div>

                    <div class="flex mt-[1.5rem]">
                        <FormKit
                            type="submit"
                            label="Créer"
                            class="btn"
                            prefix-icon="check"
                        />
                    </div>
                </FormKit>
            </div>
        </div>
    </div>
</template>

<script setup lang="ts">
import ApiService from "@/_services/api.service";
import {onMounted, ref, watch} from "vue";
import router from "@/router";
import swal from "@/_helpers/swal";
import UploadImage from "@/components/forms/UploadImage.vue";
import CustomButton from "@/components/forms/CustomButton.vue";

let categories = ref([]);
let imageMenu = ref();
const propertyTagUuid = '3172dc3a-1ed9-468d-8cbc-dff34c441361';

onMounted(async () => {
    await fetchCategories();
})
async function fetchCategories() {
    try {
        const response = await ApiService.get('categories?lvl=1&archived=false');
        categories.value = response.data.data.map((item: never) => {
            return {
                label: item.name, value: item.uuid
            };
        });
    } catch (error) {
        swal.error('Une erreur est survenue');
    }
}
async function searchTags({search}) {
    if (!search || search.length < 3) return [];
    const fetchTags = await ApiService.get(`property_values?property.uuid=${propertyTagUuid}&value=${search || ''}&status=true`);
    return fetchTags.data.data.map((val: any) => {
        return {
            label: val.value,
            value: val.uuid
        }
    });
}
const onImageUpload = (image) => {
    imageMenu.value = image;
}
const onImageRemoved = () => {
    imageMenu.value = null;
}
const onImageUploadError = (errorMsg: string) => {
    swal.error(errorMsg);
}

function getBaseUrl() {
    return window.location.origin;
}

function submitHandler(data, formNode) {
    if(!imageMenu.value){
        swal.error('l\'image est  obligatoire');
        return;
    }
    return ApiService.post("/mega_menu_categories", {
        name: data.name,
        image: imageMenu.value.uuid,
        propertyValue: data.propertyValue,
        category: data.category

    }).then(() => {
        swal.success("Mise en avant créé !", "");
        router.push({name: 'listMegaMenusCategories'});
    }).catch(({response}) => {
        response.data.errors.forEach((error) => {
            formNode.setErrors(null, {[error.property]: error.message});
            return false;
        });
    });
}

</script>


